module.exports = __webpack_public_path__ + "img/payment-icon.0ba00548.svg";